import { useReducedMotion } from "framer-motion";

const ITEMS = [
    "ASEAN",
    "Greater China",
    "Middle East",
    "Oceania",
    "North America",
    "Halal Certified",
    "Private Label",
    "OEM / ODM",
    "FMCG Distribution",
    "Cross-Border Logistics",
];

export const Marquee = () => {
    const reduce = useReducedMotion();
    const items = [...ITEMS, ...ITEMS];

    return (
        <section
            data-testid="marquee-strip"
            aria-label="Capabilities marquee"
            className="relative w-full bg-[#D69331] text-black border-y border-black/10 overflow-hidden"
        >
            <div
                className={`flex whitespace-nowrap py-5 ${
                    reduce ? "" : "marquee"
                }`}
                style={{ width: "max-content" }}
            >
                {items.map((it, i) => (
                    <span
                        key={`${it}-${i}`}
                        className="font-display uppercase text-2xl sm:text-3xl lg:text-4xl px-8 tracking-tight font-bold flex items-center gap-8"
                    >
                        {it}
                        <span
                            aria-hidden
                            className="inline-block h-2 w-2 bg-black"
                        />
                    </span>
                ))}
            </div>
        </section>
    );
};
